import './config';
import {apiBaseUrl} from './config';
import {getBaseHeader} from './utils';
import SfpBaseService from './sfp-base-service';

const PPI_REVENUES_YEARS = 'ppis/revenues/years';

export default class PPIRevenueYearService extends SfpBaseService {

  static updatePPIRevenueYear(ppi_revenue_year) {
    const body = JSON.stringify({ppi_revenue_year: {value: (ppi_revenue_year.value===null || ppi_revenue_year.value==="")  ? 0: ppi_revenue_year.value }});
    const headers = {
      ...getBaseHeader(),
      'Content-Type': 'application/json'
    };

    return fetch(`${apiBaseUrl}/ppis/${ppi_revenue_year.id}/revenue/year`, {body, headers, method: "PUT"})
      .then(super.returnResponse);
  }

}



// WEBPACK FOOTER //
// ./src/service/sfp/ppi-revenue-year-service.js